import type { JSX } from 'react';
import Box from 'carbon-react/esm/components/box';
import Loader from 'carbon-react/lib/components/loader/__next__';

export interface AdminLoaderItemsProps {
  message: string;
}

const AdminLoaderItems = ({ message }: AdminLoaderItemsProps): JSX.Element => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="400px">
      <Loader size="large" loaderLabel={message} />
    </Box>
  );
};

export default AdminLoaderItems;
